import { Component } from '@angular/core';
import { PrimeNGModule } from '../../primeng.module';
import { ContactService } from '../../services/contact/contact.service';
import { WhatsAppService } from '../../services/whats-app/whats-app.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { ContactFormComponent } from '../../shared/components/contact-form/contact-form.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [BreadcrumbComponent, ContactFormComponent, PrimeNGModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  public typeContact = ContactService.TYPE_CONTACT;

  constructor(private whatsAppService: WhatsAppService) {}

  onClickWhatsApp() {
    this.whatsAppService.setOpenWhatsApp(true);
  }
}
